/** Fetch Youtube info */
export const FETCH_YOUTUBE_INFO_REQUEST = 'FETCH_YOUTUBE_INFO_REQUEST';
export const FETCH_YOUTUBE_INFO_SUCCESS = 'FETCH_YOUTUBE_INFO_SUCCESS';
